import { type NodeProps } from "@solidtv/solid";
import { createSignal } from "solid-js";

interface FocusableButtonProps extends NodeProps {
  children: string;
  onEnter: () => void;
  autofocus?: boolean;
}

const transitionObj = {
  duration: 150,
  easing: "ease-out"
};

export default function FocusableButton(props: FocusableButtonProps) {
  const [focused, setFocused] = createSignal(false);

  return (
    <view
      {...props}
      width={280}
      height={72}
      borderRadius={36}
      color={focused() ? 0xffffffff : 0xffffff33}
      scale={focused() ? 1.05 : 1}
      transition={{ scale: transitionObj, color: transitionObj }}
      onFocusChanged={setFocused}
      onEnter={props.onEnter}
      display="flex"
      alignItems="center"
      justifyContent="center"
      forwardStates
    >
      <text
        fontSize={28}
        fontWeight="bold"
        color={focused() ? 0x000000ff : 0xffffffff}
        fontFamily="Roboto"
        y={18}
      >
        {props.children}
      </text>
    </view>
  );
}
